import React from 'react'
import Layout from '../../components/layout'
import FullWidth from '../../components/fullWidth'
import IntegrationValues from '../../components/IntegrationValues'
import Testimonial from '../../components/Testimonial'
import Seo from '../../components/seo'
import { TalkWithFoundersCta } from '../../components/SignUp'
import classnames from 'classnames'
import shareImage from '../../images/integrations/infakt/share-image.png'
import infaktLogo from '../../images/logos/infakt.svg'

import * as heroStyle from '../../components/webreport/ReportHero.module.css'
import * as style from './infakt.module.css'

const Integrations = () => (
  <Layout nakedBar trialCta>
    <Seo
      title="Integracja InFakt dla SaaS"
      description={
        'Integracja Probe + InFakt. Bezproblemowa analityka na podstawie faktur w InFakt.'
      }
      keywords={['integracja', 'infakt', 'saas', 'mrr', 'bi', 'analityka']}
      twitterImg={shareImage}
      mainpageImg={shareImage}
    />
    <FullWidth>
      <div className={heroStyle.heroContent}>
        <div className={classnames(heroStyle.heroCopy, style.heroCopyWidth)}>
          <h1 className={heroStyle.title}>
            Metryki biznesowe na podstawie faktur w InFakcie
          </h1>
          <p className={heroStyle.subtitle}>
            Integracja Probe z InFaktem działa w czasie rzeczywistym. Nie musisz
            już spędzać czasu na manualnym liczeniu metryk a wyniki masz zawsze
            na bieżąco.
          </p>
          <p className={heroStyle.subtitle}>
            Za pomocą integracji dowiesz się jaki jest Twój MRR, Expansion,
            Churn i poznasz ponad 50 innych metryk opisujących szczegółowo
            działanie Twojego biznesu.
          </p>
          <div>
            <TalkWithFoundersCta />
          </div>
        </div>
        <div className={classnames(heroStyle.heroImage, style.heroImageWidth)}>
          <div className={style.infaktLogoWrapper}>
            <img src={infaktLogo} alt="InFakt logo" />
          </div>
        </div>
      </div>
      <Testimonial
        person="Łukasz Chwistek"
        title="Operations Manager"
        url="https://edrone.me"
      >
        "Proces onboardingu jest dogłębny i szczegółowy. Zbudowanie zaufania do
        pokazywanych metryk jest jego najważniejszym celem."
      </Testimonial>
    </FullWidth>
    <IntegrationValues />
  </Layout>
)

export default Integrations
